import { Box, BoxProps, Center } from "@chakra-ui/react";
import BoldSpinner from "components/BoldSpinner";
import V2Image from "components/V2Image";
import SelectionIndicator from "components/SelectionIndicator";
import { ImageSize } from "types";

export type V2CardProps = BoxProps & {
  tokenId: number;
  imageSize?: ImageSize;
  isSelected?: boolean;
  isBusy?: boolean;
  isDisabled?: boolean;
  onClick?: (tokenId: number) => void;
};

const V2Card: React.FC<V2CardProps> = ({
  tokenId,
  imageSize,
  isDisabled = false,
  isSelected = false,
  isBusy = false,
  bg = "dark.700",
  children,
  onClick,
  ...rest
}) => (
  <Box
    bg={bg}
    p="1.5"
    w="full"
    outline="2px solid"
    userSelect="none"
    outlineColor={isSelected ? "dark.600" : "transparent"}
    cursor={isDisabled ? "not-allowed" : onClick ? "pointer" : "default"}
    transition="all 0.15s"
    borderRadius="lg"
    overflow="hidden"
    tabIndex={0}
    onClick={() => {
      if (!isDisabled && onClick) {
        onClick(tokenId);
      }
    }}
    {...rest}
  >
    <Box position="relative">
      <V2Image
        size={imageSize}
        tokenId={tokenId}
        isDisabled={isDisabled || isBusy}
      />

      <SelectionIndicator
        position="absolute"
        bg={bg}
        color="primary.500"
        top="-1.5"
        left="-1.5"
        isSelected={isSelected}
      />

      <Center
        position="absolute"
        top="-2"
        right="-2"
        bg="bright.500"
        w="10"
        h="10"
        zIndex="dropdown"
        opacity={isBusy ? "1" : "0"}
        transition="opacity 0.15s"
      >
        {isBusy && <BoldSpinner size="sm" thickness="3px" />}
      </Center>
    </Box>

    <Box>{children}</Box>
  </Box>
);

export default V2Card;
